import React from 'react'
import { inject, observer } from 'mobx-react'
import CONFIG from 'core/globals'
import { FREE_CHAT_WINDOW_DISCOUNT, formatFreeChatWindowClock } from 'core/freeChatWindow'
import { openUpgrade } from 'core/openUpgrade'

/**
 * AVN-1396 side C: once the free chat window is over, the 20% offer stays on screen above the message input with its
 * own countdown, and says so when it has run out. Side B and everyone outside the test never see it.
 */
const FreeChatWindowOfferStrip = ({ store }) => {
  if (store.freeChatWindowDiscountActive) {
    const goToUpgrade = () => openUpgrade(CONFIG.urls.upgrade(store.conversation?.otherUserProfile), CONFIG)

    const onKeyDown = e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        goToUpgrade()
      }
    }

    // Not a <button>: it renders inside the compose form, whose button rules belong to the send button.
    return (
      <div role="button" tabIndex={0} className="ccp-fcw-strip" onClick={goToUpgrade} onKeyDown={onKeyDown}>
        <span className="ccp-fcw-strip__badge">{`${FREE_CHAT_WINDOW_DISCOUNT}% OFF`}</span>
        <span className="ccp-fcw-strip__text">Your discount is still yours</span>
        <span className="ccp-fcw-strip__clock">{formatFreeChatWindowClock(store.freeChatWindowDiscountSecondsLeft)}</span>
        <span className="ccp-fcw-strip__chevron" aria-hidden="true">›</span>
      </div>
    )
  }

  if (store.freeChatWindowDiscountExpired) {
    return (
      <div className="ccp-fcw-strip ccp-fcw-strip--expired">
        <span className="ccp-fcw-strip__badge">EXPIRED</span>
        <span className="ccp-fcw-strip__text">Discount window closed · regular price applies</span>
      </div>
    )
  }

  return null
}

export default inject('store')(observer(FreeChatWindowOfferStrip))
